export const faqList = [
  {
    q: "网络爆料的今日热门话题是怎么排出来的？",
    a: "我们会在每天固定时段抓取各平台的讨论量、转发增速和互动总量，去掉重复与营销刷量后按增速加权排序。榜单每小时刷新一次，热度标识会随讨论变化上下浮动，所以同一件事在不同时间段的名次可能不一样。",
  },
  {
    q: "为什么有的爆料热度很高，却没有排在榜首？",
    a: "热度不等于可信度。对于来源单一、缺少多方印证的内容，我们会在排序上做降权处理，并在详情页标注「待核实」。榜首通常留给讨论面广、有多个信息源交叉印证的议题。",
  },
  {
    q: "榜单分为今日、本周、本月，三者有什么区别？",
    a: "今日榜反映短时间内的爆发讨论，变化最快；本周榜更看重持续性，能过滤掉一日游话题；本月榜体现长期热度，适合回顾整月里真正被反复提起的事件。",
  },
  {
    q: "网站内容会标明来源吗？",
    a: "会。每条爆料详情页都会标注信息整理来源与更新时间，并尽量呈现多方说法。如果后续出现反转或澄清，我们会在原文顶部补充更新说明，而不是直接删除。",
  },
  {
    q: "可以直接在网站上投稿或提供线索吗？",
    a: "可以。通过「联系我们」页面留下话题线索与简要说明即可，我们会安排编辑进行核实。请注意不要提交涉及他人隐私或未经证实的内容。",
  },
  {
    q: "内容更新频率是怎样的？",
    a: "爆料流全天滚动更新，通常每 30 分钟补充一批新话题；榜单每小时刷新；每日晚间会做一次当日回顾，把当天最值得回看的爆料重新整理成一份合辑。",
  },
];